import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { useThrottleFn } from 'ahooks';
import { useEffect } from 'react';

import { pageSwiperEffect } from '@src/components/swiper/page-swiper/config';

class pageSwiperStore {
  /**
   * swiperOptions 默认的属性值
   * @type {{simulateTouch: boolean, observeParents: boolean, releaseOnEdges: boolean, effect: string, mousewheel: boolean, fadeEffect: {}, slidesPerView: number, observe: boolean, direction: string}}
   */
  swiperOptions = {
    direction: 'vertical',
    slidesPerView: 1,
    observe: true,
    observeParents: true,
    mousewheel: false,
    releaseOnEdges: true,
    simulateTouch: false,
    speed: 600 
  };

  baseSwiperStore = new BaseSwiperStore({
    swiperOptions: this.swiperOptions
  });

  constructor({ effectMode = pageSwiperEffect.NORMAL, ...rest } = {}) {
    Object.assign(this, rest);
    this.baseSwiperStore.swiperOptions = { ...this.baseSwiperStore.swiperOptions, ...effectMode };
  }

  /**
   * 全屏滚动鼠标监听
   * 因为使用swiper自带的鼠标上线滚动会出现页面闪动的问题
   * 因此通过监听鼠标滚动事件来实现全屏滚动
   * @param ev
   */
  handleScroll = ev => {
    let isScrollUp;
    if (ev.wheelDelta) {
      isScrollUp = ev.wheelDelta > 0;
    } else {
      isScrollUp = ev.detail < 0;
    }

    const currentActiveIndex = this.baseSwiperStore.activeIndex;
    const nextActiveIndex = currentActiveIndex + (isScrollUp ? -1 : 1);

    /**
     * 禁止滚动到 -1 屏
     */
    if (nextActiveIndex < 0) {
      return;
    }

    if (document.getElementsByClassName('am-modal-content').length > 0) {
      return;
    }
    if (document.getElementsByClassName('c-age-modal-backdrop').length > 0) {
      return;
    }

    /**
     * 获取总屏数
     */
    const totalSwiperSlides = this.baseSwiperStore.swiperRef.current.swiper.slides.length;

    /**
     * 其他溢出场景禁止
     */
    if (nextActiveIndex > totalSwiperSlides - 1) {
      return;
    }

    /**
     * 正常场景允许滚动
     */
    this.baseSwiperStore.onChange(nextActiveIndex);
  };

  use() {
    const { run: onScroll } = useThrottleFn(this.handleScroll, { wait: 600, trailing: false });
    useEffect(
      () => {
        document.addEventListener('wheel', onScroll, false);
        return () => {
          document.removeEventListener('wheel', onScroll, false);
        };
      },
      [onScroll]
    );
  }
}

export default pageSwiperStore;
